var StoreModel = require('../../../shared/app/models/booking/store');
var WaitListAppointmentsServiceView = require('./appointment-service');

var GuestServiceModel = require('../../../shared/app/models/booking/guest-service-model');

var GuestServiceView = Backbone.Epoxy.View.extend({ //TODO move other file
  template: 'account.account-wait-list.waitListAppointmentsGuestService',

  initialize: function() {
    this.hasRendered = false;

    console.log(this.model);

    this.render();
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();

    this.$('.js-summary__wait-guest[data-id=' + this.model.get('index') + ']').text(
      this.model.getWaitTimeToArrival(this.collectionView.model));

  },

  cleanup: function() {
    this.removeBindings();
  }

});

var GuestServiceExpandedView = Backbone.Epoxy.View.extend({ //TODO move other file
  template: 'account.account-wait-list.waitListAppointmentsGuestServiceExpanded',

  computeds: {
    title: {
      deps: ['index'],
      get: function(index) {
        if (this.collectionView.model.get('guestServiceCollection').length > 1) {
          return "Guest " + (index + 1).toString() + " - Check in details";
        } else {
          return "Guest - Check in details";
        }
      }
    }
  },

  initialize: function() {
    this.hasRendered = false;

    console.log(this.model);

    this.render();
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();

    this.$('.js-summary__wait-guest').text(
      this.model.getWaitTimeToArrival(this.collectionView.model));

  },

  cleanup: function() {
    this.removeBindings();
  }

});

/**
 * View that represents a waiting list appointment
 */
var WaitListAppointmentsView = Backbone.Epoxy.View.extend({
  template: 'account.account-wait-list.waitListAppointmentsBlock',
  itemView: WaitListAppointmentsServiceView,
  guestServiceItemView: GuestServiceView,
  guestServiceExpandedItemView: GuestServiceExpandedView,

  events: {
    'click .js-waitlist-action__cancel': 'onCancelAppointment',
    'click .js-waitlist-action__register': 'onRegister',
    'click .js-waitlist-action__reviews': 'onStoreReviews',
    'click .js-waitlist-action__profile': 'onProfile',
    'click .js-waitlist-action__waitboard': 'onWaitBoard',
  },

  bindingSources: {
    guestCollection: function() {
      return new Backbone.Collection(null, {model: GuestServiceModel})
    }
  },

  initialize: function() {

    this.collection = this.model.get('services');
    this.bindingSources.guestCollection = this.model.get('guestServiceCollection');

    this.waitTimer = null;
    this.hasRendered = false;
    this.render();

    var self = this;
    $(window).resize(function() {
      self.fixContentHeight();
    });

    this.listenTo(this.model, 'change:suggestedArrivalTime', _.bind(this.setWaitTimer, this));
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  afterRender: function() {
    this.applyBindings();

    this.clearInterval();
    //this.waitTimer = setInterval(_.bind(this.setWaitTimer, this), 30000);

    //this.$('.js-my-account-wait-list--value__wait').text(this.model.getWaitTimeToArrival());
    this.setWaitTimer();

    this.fixContentHeight();
  },

  cleanup: function() {
    this.removeBindings();

    this.clearInterval();

    this.stopListening();
  },

  clearInterval: function() {
    if (this.waitTimer) {
      clearInterval(this.waitTimer);
      this.waitTimer = null;
    }
  },

  fixContentHeight: function () {
    var topBarHeight = $('.top-bar').height();
    var height = $(window).height() - topBarHeight;
    var $elem = $('#myWaitListAppointments');

    $elem.css('height', height);

    // temporary fix for Chrome's scroll issue where the user is unable to scroll until he resizes the window
    $elem.css('overflow', 'auto');
    _.delay(function() { $elem.css('overflow', ''); }, 300);
  },

  onCancelAppointment: function() {
    var options = {
      title: '',
      message: 'Are you sure you want to leave the wait list?',
      cancelLabel: 'go back',
      confirmLabel: 'yes',
      showCancelLabel: true
    };

    bookedby.app.confirmForm.show(_.bind(function(){
      this.cancelAppointments();
    }, this), function() { $('.modal-backdrop').remove(); }, options);
  },

  onRegister: function() {
    if(!bookedby.app.currentClient.get("loggedIn")) {
      bookedby.app.currentClient.clearValidation();
      bookedby.app.navigateTo('login', { onlyRegister: true });
    }
  },

  onProfile: function() {
    bookedby.app.navigateTo('profile');
  },

  onWaitBoard: function() {
    bookedby.app.navigateTo('wait-board');
  },

  cancelAppointments: function() {
    var options = {
      title: '',
      message: '',
      cancelLabel: '',
      confirmLabel: 'Ok',
      showCancelLabel: false
    };

    $.ajax({
      url: bookedby.routes.BOOKING.CANCEL_WAIT_LIST,
      contentType: 'application/json',
      data: JSON.stringify({
        waitListEntryUuid: this.model.get('waitListAppointmentUuid')
      }),
      method: 'POST',
      dataType: 'json',
      success: _.bind(function(data) {
        if (data.success) {
          this.collectionView.onCancelAppointment(this.model);

          options.message = 'You are no longer on wait list.';
          bookedby.app.confirmForm.show(function() { $('.modal-backdrop').remove(); }, function() {}, options);
        } else {
          bookedby.app.logAPIError(data.error);

          if (data.userError) {
            options.message = data.error;
            bookedby.app.confirmForm.show(function() { $('.modal-backdrop').remove(); }, function() {}, options);
          } else {
            options.message = 'There was a problem processing your request. Please try again in a few minutes.';
            bookedby.app.confirmForm.show(function() { $('.modal-backdrop').remove(); }, function() {}, options);
          }
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
      }, this)
    });
  },

  onStoreReviews: function() {
    $.ajax({
      url: bookedby.routes.REVIEWS.GET_STORE_INFO,
      contentType: 'application/json',
      data: {
        storeId: this.model.get('store').storeId,
        storeGroupUuid: window.bookedby.staticData.storeGroupId
      },
      method: 'GET',
      dataType: 'json',
      success: _.bind(function(data) {
        if (data.success) {
          var store = new StoreModel(data.store, { parse: true });
          bookedby.app.storeReviewsPopup.show(store.attributes);
        } else {
          bookedby.app.logAPIError(data.error);
        }
      }, this),
      error: _.bind(function(jqXHR, textStatus, textError) {
        bookedby.app.logAPIError(textError);
      }, this)
    });
  },

  setWaitTimer: function() {
    this.$('.js-my-account-wait-list--value__wait').text(this.model.getWaitTimeToArrival());
    this.model.get('guestServiceCollection').each(_.bind(function(guest, idx) {
      //this.$('.js-summary__wait').text(this.model.getWaitTimeToArrival());
      this.$('.js-summary__wait-guest[data-id=' + idx + ']').text(guest.getWaitTimeToArrival(this.model));
    }, this));
  }
});

module.exports = WaitListAppointmentsView;
